import React from 'react';
import useGlobalHotkey from '~app/core/useGlobalHotkey';
import withEnterToClick from '~app/core/withEnterToClick';

import createDOMPurify from 'dompurify';
import { JSDOM } from 'jsdom';

const window = new JSDOM('').window;
const DOMPurify = createDOMPurify(window);

const ClickOrEnterDiv = withEnterToClick('div');
// Confirmation dialog with ok and cancel buttons
// htmlText renders html tags in the text
function ConfirmationDialog({
  onOk,
  onCancel,
  title,
  text,
  htmlText,
  okLabel,
  cancelLabel,
  cssClass,
}) {
  useGlobalHotkey({
    hotkey: 'Escape',
    callback: onCancel,
    event: 'keyup',
    priority: 10,
    stop: true,
  });
  return (
    <div className={`ConfirmationDialog Modal__container ${cssClass}`}>
      <h1 className="ConfirmationDialog__title">{title}</h1>
      <div className="ConfirmationDialog__text">{text}</div>
      {htmlText && (
        <div
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(htmlText) }}
          className="ConfirmationDialog__htmltext"
        ></div>
      )}
      <div className="ConfirmationDialog__button-group">
        {cancelLabel && (
          <ClickOrEnterDiv
            className="ConfirmationDialog__button"
            onClick={onCancel}
            role="button"
            tabIndex={0}
          >
            {cancelLabel}
          </ClickOrEnterDiv>
        )}
        {okLabel && (
          <ClickOrEnterDiv
            className="ConfirmationDialog__button"
            onClick={onOk}
            role="button"
            tabIndex={0}
          >
            {okLabel}
          </ClickOrEnterDiv>
        )}
      </div>
    </div>
  );
}

export default ConfirmationDialog;
